import type { VehicleFinance } from '@core/Entities/Vehicle/VehicleFinance.entity';
import { Typography } from '@gds/Typography/Typography';

import styles from './RepresentativeExampleList.module.css';

type Props = {
  finance: VehicleFinance;
};

export const RepresentativeExampleList = ({ finance }: Props) => {
  const fullDisclaimer = finance.legalText?.fullDisclaimer;
  if (!fullDisclaimer) return null;

  const entries = fullDisclaimer
    .replace('Representative example: ', '')
    .split(', ')
    .map(entry => {
      const [label, value] = entry.split(': ');
      return { label, value };
    });

  return (
    <ul className={styles.entryList}>
      {entries.map(({ label, value }) => (
        <li key={label}>
          <Typography variant="textSmRegular" className={styles.entryLabel}>
            {label}
          </Typography>
          <Typography variant="textSmBold" className={styles.entryValue}>
            {value}
          </Typography>
        </li>
      ))}
    </ul>
  );
};
